import React from 'react'


export default function PermissionCard(props) {

    return (
        <div style={{ padding: "20px", marginRight: "20px" }}>
            <div style={{ display: "flex" }}>
                <span>{`${props.index + 1}-`}</span>
                <span style={{ fontWeight: "500",marginRight:"10px",wordBreak:"break-all" }}>{props.data}</span>
            </div>
        </div>
    )
}